import { ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  UpdateCandidatePositionStatusInput,
  UpdateCandidatePositionStatusOutput,
} from '../candidates.types';

export const updateCandidatePositionStatus = (builder: CandidateBuilder) =>
  builder.mutation<
    UpdateCandidatePositionStatusInput,
    UpdateCandidatePositionStatusOutput
  >({
    query: (args) => ({
      url: `/candidate-position-status/${args.data.CandidatePositionStatusId}`,
      method: 'PATCH',
      body: args.data,
      responseHandler: (response) => response.text(),
    }),
    transformResponse: (res, meta, args) => {
      if (meta?.response?.status === 200 && meta?.response?.ok) {
        if (args.data.Status === 'shortlisted') {
          successHandler(
            args.lang === ValidLanguages.es
              ? SuccessMessageEs.UPDATE_CANDIDATE_SHORTLISTED
              : SuccessMessageEn.UPDATE_CANDIDATE_SHORTLISTED,
            true
          );
        } else {
          successHandler(
            args.lang === ValidLanguages.es
              ? SuccessMessageEs.UPDATE_STATUS
              : SuccessMessageEn.UPDATE_STATUS,
            true
          );
        }
      } else {
        throw new Error();
      }
    },
    transformErrorResponse: (err, meta, args) => {
      errorHandler(
        '[updateCandidatePositionStatus]',
        (args.lang ?? 'en') === 'es'
          ? ErrorMessageEs.CanditatePositionStatusError
          : ErrorMessageEn.CanditatePositionStatusError,
        err,
        true
      );
      return err.data;
    },
  });
